import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'
// import { priorityList, statusList, typeClientList,
//   typeCList, activityClientList, workformList, stateWarehouseItemDict, booleanList } from './dictionaryvalues'
// import { logOutHard } from '../components/Login/module/login'
export let origin = window.location.hostname
export let protocol = window.location.protocol
if (origin === 'localhost' || origin === '127.0.0.1' || origin === 'dev.itti.com.pl') {
  origin = 'dev.itti.com.pl:8020'
}  else {
  origin += ':8020'
}

export const getHeaders = () => {
  let contratoken = localStorage.getItem('contratoken')
  let isRemembered = localStorage.getItem('isRemembered')
  let tokenDate = parseInt(localStorage.getItem('tokenDate'))
  let contrauser = localStorage.getItem('contrauser')
  if (contratoken && contrauser) {
    let globalHeaders = { headers: { 'x-auth-token': contratoken } }
    if (isRemembered === 'true' && ((new Date(tokenDate)).getTime() + 259200000 > (new Date()).getTime())) {
      localStorage.setItem('tokenDate', (new Date()).getTime() + 259200000) // 259200000 is 3 days
      return globalHeaders
    } else if ((new Date(tokenDate)).getTime() + 3600000 > (new Date()).getTime()) {
      localStorage.setItem('tokenDate', (new Date()).getTime() + 3600000) // 3600000 is 1 hour
      return globalHeaders
    } else {
      logOutHard()
      return ''
    }
  } else {
    logOutHard()
    return ''
  }
}

export const getHeadersDocuments = () => {
  let contratoken = localStorage.getItem('contratoken')
  let globalHeaders = { headers: { 'x-auth-token': contratoken,
    'content-Type': 'multipart/form-data; ',
    'Access-Control-Allow-Origin': '*' } }
  return globalHeaders
}

export const getHeadersFileDownload = () => {
  let contratoken = localStorage.getItem('contratoken')
  let globalHeaders = { headers: { 'x-auth-token': contratoken }, responseType: 'arraybuffer' }
  return globalHeaders
}

export const getToken = () => {
  let contratoken = localStorage.getItem('contratoken')
  return contratoken
}

export const errorHandle = (error) => {
  if (error === 401) {
    localStorage.removeItem('contratoken')
    localStorage.removeItem('isRemembered')
    localStorage.removeItem('tokenDate')
    localStorage.removeItem('contrauser')
    window.location.replace(window.location.origin)
  } else if (error === 403) {
    window.location.replace(window.location.origin)
  }
}

export function getDictionaryValue (searchValue, searchTable, searchProperty) {
  let el = searchTable.find(element => element.value === searchValue)
  if (typeof el === 'undefined') {
    switch (searchProperty) {
      case 'key': {
        return 1 // keys start from 1 to n
      }
      case 'color': {
        return 'red' // er color will be black by default
      }
      default: {
        return 'DICT NOT FOUND' // er by default will be empty string
      }
    }
  }
  return el[searchProperty]
}

export function autocompleteListHandler (searchValue, searchTable, searchProperty) {
  let list = []
  if (searchValue && searchTable && searchProperty) {
    for (let iterator = 0; iterator < searchTable.length; iterator++) {
      let element = {
        key: iterator,
        value: searchTable[iterator][searchValue],
        text: _.get(searchTable[iterator], searchProperty)
      }
      list.push(element)
    }
  }
  return { updated: new Date(), list: list }
}

export function getAllData (link) {
  let locationsList = []
  let data = []
  let total
  let page = 1
  return new Promise((resolve) => {
    axios.get(`${protocol}//${origin}${link}&page=0`, getHeaders())
      .then((json) => {
        total = json.data.totalElements
        data = data.concat(json.data.content)
        while (page * 1000 < total) {
          locationsList.push(new Promise((resolve) => {
            axios.get(`${protocol}//${origin}${link}&page=${page}`, getHeaders())
              .then((json) => {
                resolve(json.data.content)
              })
              .catch((error) => {
                console.log(error)
                resolve()
              })
          }))
          page++
        }
        Promise.all(locationsList).then(values => {
          values.map((object) => {
            data = data.concat(object)
          })
          resolve(data)
        })
      })
      .catch((error) => {
        console.log(error)
        resolve()
      })
  })
}

export function getRows (params, apiUrl, baseThis, mode, filterSpecimen = '', isPinned = false, staList = statusList,
  customList, productionOperationList = null, typeProductList = null, productGroups = []) {
  if (!staList) {
    staList = statusList
  }
  let page = 0
  if (params.startRow > 0) {
    page = params.startRow / 100
  }
  baseThis.gridApi.hideOverlay()
  let sortParams = params.sortModel
  let sortValue = ''
  if (sortParams.length !== 0 || typeof sortParams === 'undefined') {
    if (sortParams[0].colId === 'status' || sortParams[0].colId === 'priority' ||
    sortParams[0].colId === 'client' || sortParams[0].colId === 'type' ||
    sortParams[0].colId === 'clientType' || sortParams[0].colId === 'activity' ||
    sortParams[0].colId === 'state') {
      sortValue = `&sort=${sortValue}${sortParams[0].colId}.name,${sortParams[0].sort}`
    } else {
      sortValue = `&sort=${sortValue}${sortParams[0].colId},${sortParams[0].sort}`
    }
  }
  let filterParams = params.filterModel
  let query = ''
  if (Object.keys(filterParams).length !== 0 && filterParams.constructor === Object) {
    let objectKey = Object.keys(filterParams)
    query = '&filter='
    for (let i = 0; i < Object.keys(filterParams).length; i++) {
      let queryName = objectKey[i]
      let queryValue = filterParams[queryName].filter
      switch (true) {
        case (queryName === 'issueDate' || queryName === 'withdrawDate' ||
          queryName === 'dateExpectedExecutionFrom' || queryName === 'dateExpectedExecutionTo' ||
          queryName === 'dateOrderDone' || queryName === 'issueDate' ||
          queryName === 'withdrawDate' || queryName === 'ended' ||
          queryName === 'deadline'):
          queryValue = moment(queryValue).format('X')
          query = `${query}${queryName}:${queryValue},`
          break
        case (queryName === 'status' || queryName === 'priority' ||
          queryName === 'type' || queryName === 'activity' ||
          queryName === 'clientType' || queryName === 'workForm' ||
          queryName === 'state' || queryName === 'productionOperation' ||
          queryName === 'sellable' || queryName === 'externalUser' ||
          queryName === 'blocked' || queryName === 'purchaseBlock' ||
          queryName === 'defaultOperation' || queryName === 'defaultMember' ||
          queryName === 'accepted' || queryName === 'planned'):
          let value = baseThis.gridApi.getFilterInstance(queryName).model.selectedValuesMap
          if (baseThis.gridApi.getFilterInstance(queryName).model.selectedValuesCount > 0) {
            let keys = Object.keys(value)
            let addName = '.name'
            let separatorBefore = '('
            let separatorAfter = ')'
            const englishLabels = keys.map((key) => {
              let list = []
              switch (queryName) {
                case 'status':
                  list = staList
                  break
                case 'priority':
                  list = priorityList
                  break
                case 'type':
                  if (customList) {
                    list = customList
                  } else {
                    list = typeClientList
                  }
                  break
                case 'productionOperation':
                  if (productionOperationList) {
                    list = productionOperationList
                  }
                  break
                case 'activity':
                  list = activityClientList
                  break
                case 'clientType':
                  list = typeCList
                  break
                case 'state':
                  list = stateWarehouseItemDict
                  break
                case 'productIn.type':
                  list = typeProductList
                  break
                case 'workForm':
                  list = workformList
                  addName = ''
                  break
                case 'sellable':
                  list = booleanList
                  addName = ''
                  separatorBefore = ''
                  separatorAfter = ''
                  break
                case 'externalUser':
                  list = booleanList
                  addName = ''
                  separatorBefore = ''
                  separatorAfter = ''
                  break
                case 'blocked':
                  list = booleanList
                  addName = ''
                  separatorBefore = ''
                  separatorAfter = ''
                  break
                case 'purchaseBlock':
                  list = booleanList
                  addName = ''
                  separatorBefore = ''
                  separatorAfter = ''
                  break
                case 'defaultOperation':
                  list = booleanList
                  addName = ''
                  separatorBefore = ''
                  separatorAfter = ''
                  break
                case 'defaultMember':
                  list = booleanList
                  addName = ''
                  separatorBefore = ''
                  separatorAfter = ''
                  break
                case 'accepted':
                  list = booleanList
                  addName = ''
                  separatorBefore = ''
                  separatorAfter = ''
                  break
                case 'planned':
                  list = booleanList
                  addName = ''
                  separatorBefore = ''
                  separatorAfter = ''
                  break
              }
              if (list.length !== 0) {
                let encodedValue = encodingQuery(_.find(list, { text: key }).value)
                return encodedValue
              }
            }
            )
            if (query !== '&filter=') {
              query += `&filter=${queryName}${addName}:${separatorBefore}${englishLabels[0]}${separatorAfter}`
              englishLabels.map((key) => {
                if (key !== englishLabels[0]) {
                  query += `&filter=${queryName}${addName}:${separatorBefore}${key}${separatorAfter}`
                }
              }
              )
            } else {
              query = `${query}${queryName}${addName}:${separatorBefore}${englishLabels[0]}${separatorAfter}`
              englishLabels.map((key) => {
                if (key !== englishLabels[0]) {
                  query += `&filter=${queryName}${addName}:${separatorBefore}${key}${separatorAfter}`
                }
              }
              )
            }
          }
          break
        default:
          let queryValueEncode = encodingQuery(queryValue)
          query = `${query}&filter=${queryName}:${queryValueEncode}`
          break
      }
    }
  }
  let modeType = ''
  if (mode && mode[0] === '!') {
    modeType = `&filter=internalOrder.type.name:${mode.slice(1)}`
  } else if (mode) {
    modeType = `&filter=type.name:${mode}`
  }
  if (productGroups.length) {
    console.log(productGroups)
    productGroups.map((group) => {
      query = `${query}&nestedFilter=groups.metaUuid:(${group})`
    })
  }
  axios.get(
    `${protocol}//${origin}/api/${apiUrl}?size=100&page=${page}${filterSpecimen}${sortValue}${query}${modeType}`,
    getHeaders()
  )
    .then((json) => {
      let data = json.data.content
      if (apiUrl === 'ctx/client-order/client-orders') {
        for (let i = 0; i < data.length; i++) {
          data[i].progress = data[i].status.order * 4
        }
      }
      if (json.data.totalElements === 0) {
        baseThis.gridApi.showNoRowsOverlay()
      } else {
        baseThis.gridApi.hideOverlay()
      }
      params.successCallback(data, json.data.totalElements)
      baseThis.setState({
        totalElements: json.data.totalElements,
        pinnedBottomRowData: isPinned && baseThis.createData(json.data.content)
      })
    })
    .catch((data) => {
      baseThis.gridApi.showNoRowsOverlay()
      params.successCallback([], 0)
    })
}

function encodingQuery (queryValueParam) {
  return encodeURIComponent(queryValueParam)
  .replace(/[!’()]/g, encodeURI)
  .replace(/\*/g, '%2A')
  .replace(/!/g, '%21')
  .replace(/\./g, '%2E')
  .replace(/_/g, '%5F')
  .replace(/-/g, '%2D')
}



// WEBPACK FOOTER //
// ./src/store/addons.js